type AuthStatus = "loading" | "authenticated" | "unauthenticated";

export const canRenderProtectedTaskArea = (
  hasMounted: boolean,
  status: AuthStatus,
  accessToken: string | null,
): boolean => hasMounted && status === "authenticated" && accessToken !== null;
